/**
 * Cover art for trip cards on discovery surfaces.
 *
 * A trip carries no cover photo of its own — trip photos live in the media
 * plane and are only served as short-TTL expiring URLs after an authorization
 * check, which is the wrong shape for a public browse grid. So a stable hash of
 * the trip id picks one of a few travel images: decorative, never claimed to be
 * the traveler's own photo, and **the same trip always gets the same cover** so
 * a grid doesn't reshuffle between renders.
 *
 * Mirrors `lib/covers.ts` in the mobile app — same list, same hash, so a trip
 * looks the same on both clients.
 */

const COVERS = [
  'https://images.unsplash.com/photo-1467269204594-9661b134dd2b?w=700&q=80&auto=format&fit=crop',
  'https://images.unsplash.com/photo-1476610182048-b716b8518aae?w=700&q=80&auto=format&fit=crop',
  'https://images.unsplash.com/photo-1540959733332-eab4deabeeaf?w=700&q=80&auto=format&fit=crop',
  'https://images.unsplash.com/photo-1493976040374-85c8e12f0c0e?w=700&q=80&auto=format&fit=crop',
  'https://images.unsplash.com/photo-1504893524553-b855bce32c67?w=700&q=80&auto=format&fit=crop',
  'https://images.unsplash.com/photo-1476514525535-07fb3b4ae5f1?w=700&q=80&auto=format&fit=crop',
];

export function coverFor(id: string): string {
  let hash = 0;
  for (let i = 0; i < id.length; i += 1) hash = (hash * 31 + id.charCodeAt(i)) % 9973;
  return COVERS[hash % COVERS.length];
}
